
import Loading from 'vux/src/components/loading/index.vue'
import querystring from 'vux/src/tools/querystring/index.js'

import { mapState } from 'vuex'

export default {
name: 'App',
components: {
Loading,
},
created() {
var items = window.location.href.split('?');
var code = null;
if(items.length == 2) {
var params = items[1];
var paramsObj = querystring.parse(params);
code = paramsObj['code'];
}
if(!code) {
var appid = "wxea49df06fb9fb626";
var loginUrl = encodeURIComponent(window.location);
var scope = "snsapi_userinfo";
window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appid + "&redirect_uri=" + loginUrl + "&response_type=code&scope=" + scope + "&state=STATE#wechat_redirect";
}
else {

this.$ajax.post({
url: this.$apiUrls.wechatLogin,
isLoading: false,
data: { 'code': code },
success: res => {
const userId = res.data.id;
window.userId = userId;
if(res.data.status == 0) {
this.$vux.toast.text(res.data.msg, 'center');
return;
}
if(window.loaduser) {
window.loaduser();
}
if(window.loadgoodslist) {
window.loadgoodslist();
}
}
});
}
},
computed: {
...mapState({
isLoading: state => state.vux.isLoading,
text: state => state.vux.loaddingText
})
},
methods: {
getUrlParam(name) {
var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
var r = window.location.search.substr(1).match(reg);  

if (r != null) {
return unescape(r[2]);    
}
return null;
}
}
}




// WEBPACK FOOTER //
// ./src/App.vue